// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#gamePage {
	display:none;
  position:absolute;
  top:0;
  right:0;
  width: 129rem;
  height:108rem;
  justify-content: center;
  align-items: center;
  z-index:2;
}

.gaming #gamePage,
.start #gamePage {
	display:flex;
}

.memory-game {
  width: 114rem;
  margin: 11rem auto 0;
  display: flex;
  flex-wrap: wrap;
  perspective: 1000px;
}

.memory-game * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.memory-card {
  width: 20%;
  aspect-ratio: 1/1;
  position: relative;
  transform: scale(1);
  transform-style: preserve-3d;
  transition: transform 0.5s;
  cursor: pointer;
}

.memory-card:active {
  transform: scale(0.97);
  transition: transform 0.2s;
}

.memory-card.flip {
  transform: rotateY(180deg);
}

.front-face,
.back-face {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  backface-visibility: hidden;
}

.front-face {
  transform: rotateY(180deg);
}
`, "",{"version":3,"sources":["webpack://./public/components/Game/game.css"],"names":[],"mappings":"AAAA;CACC,YAAY;EACX,iBAAiB;EACjB,KAAK;EACL,OAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;CAEC,YAAY;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["#gamePage {\n\tdisplay:none;\n  position:absolute;\n  top:0;\n  right:0;\n  width: 129rem;\n  height:108rem;\n  justify-content: center;\n  align-items: center;\n  z-index:2;\n}\n\n.gaming #gamePage,\n.start #gamePage {\n\tdisplay:flex;\n}\n\n.memory-game {\n  width: 114rem;\n  margin: 11rem auto 0;\n  display: flex;\n  flex-wrap: wrap;\n  perspective: 1000px;\n}\n\n.memory-game * {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.memory-card {\n  width: 20%;\n  aspect-ratio: 1/1;\n  position: relative;\n  transform: scale(1);\n  transform-style: preserve-3d;\n  transition: transform 0.5s;\n  cursor: pointer;\n}\n\n.memory-card:active {\n  transform: scale(0.97);\n  transition: transform 0.2s;\n}\n\n.memory-card.flip {\n  transform: rotateY(180deg);\n}\n\n.front-face,\n.back-face {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n  backface-visibility: hidden;\n}\n\n.front-face {\n  transform: rotateY(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
